import { cva } from 'class-variance-authority';
export const bannerVariants = cva('relative overflow-hidden font-gotham', {
    variants: {
        variant: {
            promo: 'py-5 md:py-8 xl:py-10 px-6 md:px-12 xl:px-14',
            intro: 'w-screen left-1/2 transform -translate-x-1/2 bg-[#F5F7F8] px-6 md:px-12 xl:px-[6.25rem] py-10 xl:py-20',
            stack: 'w-full grid grid-cols-1 text-brand-navy md:grid-cols-[1.64fr_1fr] xl:grid-cols-[1.474fr_1fr]',
            video: 'w-full [&>div]:w-full [&>div]:h-[297px] xl:[&>div]:h-[513px] [&_img]:object-center',
        },
    },
    compoundVariants: [
        {
            variant: ['promo', 'intro'],
            className: 'flex justify-center',
        },
    ],
    defaultVariants: {
        variant: 'promo',
    },
});
export const containerVariants = cva('w-full', {
    variants: {
        variant: {
            promo: 'max-w-[1328px] bg-brand-navy-2 text-white rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center gap-6 md:gap-8 px-5 md:px-8 py-12 xl:p-[3.75rem]',
            intro: 'max-w-[1240px] pb-5 md:pb-10 xl:pb-[3.75rem] md:px-10 xl:px-20 relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-1 xl:after:h-1.5 after:bg-gradient-bar-1',
            stack: 'bg-brand-navy-3 order-2 md:order-1 space-y-8 px-6 pt-8 pb-[1.375rem] md:pt-14 md:pb-[4.75rem] md:pl-14 md:pr-6 xl:pl-28 xl:pr-10',
        },
    },
    defaultVariants: {
        variant: 'promo',
    },
});
export const textContainerVariants = cva('', {
    variants: {
        variant: {
            promo: 'space-y-2.5 md:space-y-3.5 xl:space-y-6 max-w-[800px]',
            intro: 'space-y-3.5 xl:space-y-5 max-w-[1048px]',
            stack: 'space-y-4 max-w-[1440px] min-[1440px]:ml-auto',
        },
    },
    defaultVariants: {
        variant: 'promo',
    },
});
export const titleVariants = cva('tracking-[-0.03em]', {
    variants: {
        variant: {
            promo: 'text-[2rem]/[1.3] xl:text-5xl/[1.3] mb-3.5 xl:mb-6 text-2xl xl:text-5xl',
            intro: 'text-2xl/[1.4] xl:text-5xl/[1.2] text-brand-navy',
            stack: '',
        },
        size: {
            default: 'font-medium',
            small: 'font-normal',
        },
    },
    compoundVariants: [
        {
            variant: 'stack',
            size: 'default',
            className: 'text-[2rem]/[1.5] xl:text-5xl/[1]',
        },
        {
            variant: 'stack',
            size: 'small',
            className: 'text-2xl/[1.4]',
        },
    ],
    defaultVariants: {
        variant: 'promo',
        size: 'default',
    },
});
export const descriptionVariants = cva('', {
    variants: {
        variant: {
            promo: 'text-xl/[1.5]',
            intro: 'text-[#656565] tracking-[-0.03em] text-base md:text-lg/[1.5] xl:text-[2rem]/[1.5]',
            stack: '',
        },
        size: {
            default: '',
            small: '',
        },
    },
    compoundVariants: [
        {
            variant: 'stack',
            size: 'default',
            className: 'text-lg xl:text-2xl/[1.5]]',
        },
        {
            variant: 'stack',
            size: 'small',
            className: 'text-base xl:text-lg/[1.5]',
        },
    ],
    defaultVariants: {
        variant: 'promo',
        size: 'default',
    },
});
